import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ENV_CONFIG, SharedConfig } from '@emi/shared/models';

@NgModule({
    declarations: [],
    imports: [CommonModule],
})
export class SharedDataAccessModule {
    static forRoot(config: SharedConfig): ModuleWithProviders<SharedDataAccessModule> {
        return {
            ngModule: SharedDataAccessModule,
            providers: [
                {
                    provide: ENV_CONFIG,
                    useValue: config,
                },
            ],
        };
    }
}
